module.exports = __webpack_public_path__ + "static/media/write2raise_circles.b68c28b4.png";